<template>
  <b-navbar type="light" fixed="top" class="border-bottom" toggleable="xl">
    <b-navbar-brand>
      <b-navbar-nav class="brand">
        <b-nav-item :to="{ name: 'admin' }" :label="$t('_home')">
          {{ $t('bba.default') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse" />

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="navbar-links">
        <b-nav-item v-for="section in sections" :key="section.id"
                    :to="{ name: section.name }"
        >
          {{ $tc(section.label + '.default', 2) }}
        </b-nav-item>
      </b-navbar-nav>

      <b-nav-item-dropdown v-if="isAdmin" text="Admin">
        <b-dropdown-item v-for="section in adminSections" :to="{name: section.name}">
          {{ $tc(section.label + '.default', 2) }}
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <b-navbar-nav class="row ml-auto navbar-login">
        <b-nav-text class="v-align">{{ login }}</b-nav-text>
        <logout-button size="sm" />
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar'
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav'
import bNavbarToggle from 'bootstrap-vue/es/components/navbar/navbar-toggle'
import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand'
import bNavItem from 'bootstrap-vue/es/components/nav/nav-item'
import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown'
import bNavText from 'bootstrap-vue/es/components/nav/nav-text'
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item'
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse'
import logoutButton from '@/components/backoffice/button/logout'

export default {
  components: {
    bNavbar,
    bNavbarToggle,
    bCollapse,
    bNavbarNav,
    bNavItem,
    bNavItemDropdown,
    bDropdownItem,
    bNavbarBrand,
    logoutButton,
    bNavText
  },

  data () {
    return {
      sections: [
        { label: 'company', name: 'company_list' },
        { label: 'user', name: 'user_list' },
        { label: 'hotel', name: 'hotel_list' },
        { label: 'location', name: 'location_list' },
        { label: 'event', name: 'event_list' },
        { label: 'news', name: 'news_list' },
        { label: 'message', name: 'message_list' },
        { label: 'surveyReply', name: 'surveyReply_list' },
        { label: 'maillog', name: 'maillog_list' },
        { label: 'zone', name: 'zone_list' }
      ],
      adminSections: [
        //{ label: 'bbacontact', name: 'bbacontact_list' },
        { label: 'help', name: 'help_list' },
        { label: 'surveyQuestion', name: 'surveyQuestion_list' },
        { label: 'surveyQuestionTraveller', name: 'surveyQuestionTraveller_list' },
        { label: 'mailtpl', name: 'mailtpl_list' },
        { label: 'cbConfiguration', name: 'admin_cb' }
      ]
    }
  },

  computed: {
    login: function () {
      return this.$store.getters['security/login']
    },

    isAdmin () {
      return this.$store.getters['security/hasRole']('ROLE_BBA_ADMIN')
    }
  }
}
</script>
